import { filter, map, pipe, uniq } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { PROMOTION_ITEM_TYPES } from '../../../constants';
import { checkIsActivePromo } from '../../../utils';
import { usePromotionsSelector } from '../../store';
import { PromotionApiItem, PromotionsState, Selector } from '../../types';

export const selectActiveTournamentsIds = (): Selector<number[]> =>
  createSelector(
    (state: PromotionsState) => state.promotions,
    (promotions) =>
      pipe(
        filter((promotion: PromotionApiItem) => {
          return (
            promotion.type === PROMOTION_ITEM_TYPES.TOURNAMENT &&
            promotion.tournamentId != null &&
            !!Number(promotion.tournamentId) &&
            promotion.enabled &&
            checkIsActivePromo(promotion.showFrom, promotion.showTo, false)
          );
        }),
        map((promotion: PromotionApiItem) => Number(promotion.tournamentId)),
        uniq
      )(promotions)
  );

export const useGetActiveTournamentsIds = () =>
  usePromotionsSelector(selectActiveTournamentsIds, [], shallow);
